import React from "react";
import { Route, Routes } from "react-router-dom";

import ContactFormPage from "@/components/screens/ContactFormPage";
import Contacts from "@/components/screens/Contacts";
import { CONTACT_FORM_PAGE_MESSAGES } from "@/messages/contacts/contact-form-page.messages";
import { CONTACTS_MESSAGES } from "@/messages/contacts/contacts.messages";

const ContactsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Contacts messages={CONTACTS_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<ContactFormPage messages={CONTACT_FORM_PAGE_MESSAGES} />}
      />
      <Route
        path="/update/:contactId/:lang"
        element={<ContactFormPage messages={CONTACT_FORM_PAGE_MESSAGES} isEditing />}
      />
      <Route path="/" element={<Contacts messages={CONTACTS_MESSAGES} />} />
    </Routes>
  );
};

export default ContactsPage;
